"use strict";

var Format = require('./lib/format');
/**
 * Export default singleton.
 *
 * @api public
 */


exports = module.exports = Format;